import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { useState } from "react";
import classes from "./styles.module.scss";
import { CollapsibleSectionItem } from "@/ui";

export default function CollapsibleSection({
  className,
  bgColor,
  title,
  titleColor,
  description,
  items,
  defaultActiveKey = 0,
  md = 8,
}) {
  const [active, setActive] = useState(defaultActiveKey);

  if (items.length === 0) return null;

  return (
    <div className={clsx(className, bgColor, classes.collapsible)}>
      <Container>
        {title && (
          <>
            <h2 className={titleColor}>{title}</h2>
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </>
        )}
        <Row>
          <Col xs={12} md={md}>
            {items.map(({ title, body }, k) => (
              <CollapsibleSectionItem
                key={k}
                title={title}
                body={body}
                active={k === active}
                onClick={() => setActive(k === active ? null : k)}
              />
            ))}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
